import { watchBanOrUnBanAuthor } from 'store/global/authors/sagas/watchBanOrUnBanUser';
import { watchGetAuthors } from './sagas/watchGetAuthors';
import { watchLoadmoreAuthors } from './sagas/watchLoadmoreAuthors';
import { watchUpdateAuthorPlan } from './sagas/watchUpdateAuthorPlan';
import { watchUpdateAuthorRole } from './sagas/watchUpdateAuthorRole';

export const sagasAuthors = [watchGetAuthors, watchLoadmoreAuthors, watchUpdateAuthorRole, watchUpdateAuthorPlan, watchBanOrUnBanAuthor];
